import { BehaviorSubject } from 'rxjs';
import { Message } from './message';

export class MessagesRepository {
  private messagesLobby: Message[] = [];
  onMessagesLobby = new BehaviorSubject<Message[]>([]);

  onMessageLobby(msg: Message) {
    this.messagesLobby.push(msg);
    this.onMessagesLobby.next([...this.messagesLobby]);
  }

  cleanMessagesLobby() {
    this.messagesLobby.length = 0;
  }
}
